/**
 * Turn a search hit path into a route this CRM actually has.
 * Older indexes used placeholder URLs that fell through to the Leads home page.
 */
export function searchHitHref(path: string | null | undefined): string {
  const raw = String(path || '').trim();
  if (!raw.startsWith('/')) return '/project-hub';

  let url: URL;
  try {
    url = new URL(raw, 'http://local');
  } catch {
    return '/project-hub';
  }
  const pathname = url.pathname.replace(/\/+$/, '') || '/';
  const q = url.searchParams;

  if (pathname === '/leads') {
    const leadId = q.get('lead');
    return leadId ? `/client/${encodeURIComponent(leadId)}` : '/leads';
  }

  if (pathname.startsWith('/projects/')) {
    const projectId = decodeURIComponent(pathname.slice('/projects/'.length).split('/')[0] || '');
    if (!projectId) return '/project-hub';
    const next = new URLSearchParams();
    const task = q.get('task');
    const file = q.get('file');
    if (task) next.set('task', task);
    if (file) {
      next.set('tab', 'files');
      next.set('file', file);
    }
    const search = next.toString();
    return `/project-hub/${encodeURIComponent(projectId)}${search ? `?${search}` : ''}`;
  }

  if (pathname === '/projects') return '/project-hub';
  if (pathname === '/billing') {
    const bill = q.get('bill');
    return bill ? `/billing-payables?bill=${encodeURIComponent(bill)}` : '/billing-payables';
  }
  if (pathname === '/purchasing' && q.get('po') && !q.get('pr')) {
    return `/purchasing?pr=${encodeURIComponent(q.get('po') || '')}`;
  }
  if (pathname === '/mail') {
    const thread = q.get('thread');
    return thread ? `/executive?thread=${encodeURIComponent(thread)}` : '/executive';
  }
  if (pathname === '/meetings' || pathname === '/files') return '/project-hub';

  return `${pathname}${url.search}`;
}
